var _defs, _sodipodiNamedview, _metadata, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVividseats(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsdc: "http://purl.org/dc/elements/1.1/",
    xmlnscc: "http://creativecommons.org/ns#",
    xmlnsrdf: "http://www.w3.org/1999/02/22-rdf-syntax-ns#",
    xmlnssvg: "http://www.w3.org/2000/svg",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnssodipodi: "http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd",
    xmlnsinkscape: "http://www.inkscape.org/namespaces/inkscape",
    width: "188.91251mm",
    height: "35.454166mm",
    viewBox: "0 0 188.91251 35.454166",
    id: "svg8",
    inkscapeversion: "0.92.5 (2060ec1f9f, 2020-04-08)",
    sodipodidocname: "vividseats.svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs2"
  })), _sodipodiNamedview || (_sodipodiNamedview = /*#__PURE__*/React.createElement("sodipodiNamedview", {
    id: "base",
    pagecolor: "#ffffff",
    bordercolor: "#666666",
    borderopacity: 1,
    inkscapepageopacity: 0,
    inkscapepageshadow: 2,
    inkscapezoom: 1.1894531,
    inkscapecx: 452.7146,
    inkscapecy: 110.10084,
    "inkscapedocument-units": "mm",
    "inkscapecurrent-layer": "layer1",
    showgrid: "false",
    "fit-margin-top": 0,
    "fit-margin-left": 0,
    "fit-margin-right": 0,
    "fit-margin-bottom": 0,
    "inkscapewindow-width": 1920,
    "inkscapewindow-height": 1017,
    "inkscapewindow-x": 1912,
    "inkscapewindow-y": 70,
    "inkscapewindow-maximized": 1
  })), _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", {
    id: "metadata5"
  }, /*#__PURE__*/React.createElement("rdfRDF", null, /*#__PURE__*/React.createElement("ccWork", {
    rdfresource: ""
  }, /*#__PURE__*/React.createElement("dcFormat", null, "image/svg+xml"), /*#__PURE__*/React.createElement("dcType", {
    rdfresource: "http://purl.org/dc/dcmitype/StillImage"
  }), /*#__PURE__*/React.createElement("dcTitle", null))))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "VividSeats") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    inkscapelabel: "Layer 1",
    inkscapegroupmode: "layer",
    id: "layer1",
    transform: "translate(-11.291511,-126.75344)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g831",
    transform: "matrix(1.0675902,0,0,1.1079427,11.176562,126.65579)",
    style: {
      fill: "none",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "g829",
    transform: "translate(-17.40874,-9.911865)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "wordmark",
    transform: "translate(37.5)",
    style: {
      fill: "#04092c"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "path815",
    d: "m 90.619662,19.641924 c 4.198767,0 6.637161,1.635309 6.637161,4.598088 v 0 h -4.662201 c 0,-1.049259 -0.771386,-1.604213 -2.037077,-1.604213 -1.018727,0 -1.698255,0.494267 -1.698255,1.20316 0,0.679264 0.432187,1.111413 1.635761,1.419215 v 0 l 3.149169,0.864262 c 2.346535,0.617146 3.766579,2.036362 3.766579,4.28878 0,3.085621 -2.563006,4.90589 -6.514432,4.90589 -4.228507,0 -7.036971,-1.975676 -7.036971,-4.876299 v 0 h 4.691942 c 0,1.0182 0.98748,1.728523 2.438394,1.728523 1.018727,0 1.729125,-0.494268 1.729125,-1.357061 0,-0.679264 -0.338823,-1.080317 -1.60489,-1.388157 v 0 l -3.117922,-0.771009 c -2.377783,-0.586051 -3.735333,-2.098518 -3.735333,-4.350936 0,-2.808878 2.531759,-4.660243 6.35895,-4.660243 z m 15.859168,0 c 4.63095,0 7.78012,2.869565 7.78012,7.066562 0,0.769542 -0.0312,1.232788 -0.12424,2.065953 h -10.99028 c 0.0934,1.944616 1.3888,2.993875 3.48837,2.993875 1.45091,0 2.37778,-0.401091 2.77872,-1.327507 h 4.63133 c -0.46343,2.93172 -3.45712,4.876299 -7.40854,4.876299 -5.06352,0 -8.181443,-2.869528 -8.181443,-7.837572 0,-4.8763 3.180043,-7.83761 8.025963,-7.83761 z m 43.69871,0 c 4.19877,0 6.63717,1.635309 6.63717,4.598088 h -4.6622 c 0,-1.049259 -0.77139,-1.604213 -2.03708,-1.604213 -1.01873,0 -1.69826,0.494267 -1.69826,1.20316 0,0.679264 0.43219,1.111413 1.63614,1.419215 l 3.14879,0.864262 c 2.34691,0.617146 3.76658,2.036362 3.76658,4.28878 0,3.085621 -2.56263,4.90589 -6.51443,4.90589 -4.227,0 -7.03697,-1.975676 -7.03697,-4.876299 h 4.69194 c 0,1.0182 0.98748,1.728523 2.43839,1.728523 1.01873,0 1.72913,-0.494268 1.72913,-1.357061 0,-0.679264 -0.33882,-1.080317 -1.60489,-1.388157 l -3.11792,-0.771009 c -2.37779,-0.586051 -3.73533,-2.098518 -3.73533,-4.350936 0,-2.808878 2.53175,-4.660243 6.35894,-4.660243 z m -27.62722,-0.0018 c 2.16169,0 3.85843,1.018162 4.6622,2.530629 v 0 -2.129576 h 4.69194 v 14.873076 h -4.69194 v -2.097049 c -0.80226,1.481408 -2.65449,2.49957 -4.72281,2.49957 -4.44611,0 -7.00874,-3.363832 -7.00874,-7.839078 0,-4.444149 2.74785,-7.837572 7.06935,-7.837572 z M 82.437093,13.271755 v 21.617794 h -4.691942 v -2.09848 c -0.802257,1.481371 -2.654488,2.499533 -4.722812,2.499533 -4.446107,0 -7.007231,-3.363832 -7.007231,-7.837572 0,-4.444149 2.747853,-7.837572 7.069348,-7.837572 2.161689,0 3.858438,1.018162 4.662201,2.530629 v -7.257168 z m 57.884477,1.527413 v 5.242341 h 2.60856 v 3.733789 h -2.60856 v 11.139211 h -4.72281 V 23.775298 h -2.34654 v -3.733789 h 2.34654 V 16.42755 Z m -118.072947,5.215498 3.334392,9.35004 3.334016,-9.35004 h 5.248364 L 27.713457,34.887742 H 23.452573 L 17.031318,20.014666 Z m 17.842029,0 V 34.887742 H 35.39871 V 20.014666 Z m 6.485443,0 3.334016,9.35004 3.334392,-9.35004 h 5.248364 L 52.040553,34.887742 H 47.779669 L 41.358601,20.014666 Z m 17.83977,0 V 34.887742 H 59.871876 V 20.014666 Z m 59.431385,3.575296 c -2.19105,0 -3.5501,1.635271 -3.5501,3.887689 0,2.252418 1.35755,3.918787 3.5501,3.918787 2.34692,0.0015 3.55049,-1.758114 3.55049,-3.918787 0,-2.129576 -1.20357,-3.887689 -3.55049,-3.887689 z m -49.467361,-0.02613 c -2.191054,0 -3.55011,1.635309 -3.55011,3.887727 0,2.252418 1.35755,3.918787 3.55011,3.918787 2.346535,0.0015 3.550485,-1.758152 3.550485,-3.918787 0,-2.129614 -1.20395,-3.887727 -3.550485,-3.887727 z M 106.44758,22.81929 c -2.03708,0 -3.2719,1.20316 -3.30315,3.023466 h 6.45232 c -0.0309,-1.974207 -1.14146,-3.023466 -3.14917,-3.023466 z",
    "inkscapeconnector-curvature": 0
  }))), /*#__PURE__*/React.createElement("g", {
    id: "logoMark",
    transform: "translate(0,-6)",
    style: {
      fillRule: "nonzero"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "g826",
    transform: "translate(17.516411,16)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "polygon818",
    points: "30.82805,10.625067 24.345656,21.846537 6.136042,10.625067 ",
    style: {
      fill: "#0983b6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "polygon820",
    points: "6.1357409,10.625255 6.1364561,10.62533 6.136042,10.625067 30.82805,10.625067 36.966991,0.00027557582 6.1349126,10.625217 ",
    style: {
      fill: "#0951b6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "polygon822",
    points: "6.142555,10.638507 6.1347997,10.624427 24.345354,21.846499 18.479354,32 ",
    style: {
      fill: "#13bdc3"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "polygon824",
    points: "0,0.0010891269 36.967179,0 6.1391291,10.622996 ",
    style: {
      fill: "#ce3197"
    }
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVividseats);
export default __webpack_public_path__ + "static/media/vividseats.3e5c911d536e78f317d6126022381aeb.svg";
export { ForwardRef as ReactComponent };